<template>
  <div class="seestadtbot-frontpage">
    <div class="top-grid">
      <div class="top-grid-content">
        <h2>Verwende den Bot in Chat-Apps</h2>
        <div class="messenger-link-buttons">
          <a href="https://telegram.me/SeestadtBot" target="_blank"><img src="../assets/seestadtbot/telegram.svg" alt="" />Telegram</a>
          <a href="https://m.me/SeestadtBot" target="_blank"><img src="../assets/seestadtbot/messenger.svg" alt="" />Messenger</a>
        </div>
        <h2>Du kannst fragen &hellip;</h2>
        <ul>
          <li>wann der 🚌 Bus bei der Johann-Kutschera-Gasse kommt <button @click="sendText('Bus JKG')">Bus JKG</button></li>
          <li>wann die nächste 🚇 U2 von der Seestadt abfährt <button @click="sendText('U2 Seestadt')">U2 Seestadt</button></li>
          <li>welche Öffi-Stationen es gibt <button @click="sendText('S')">S</button></li>
          <li>ob dein Lieblingsgeschäft offen hat, zum Beispiel
            <button @click="sendText('United in Cycling')">United in Cycling</button>
            <!--
            <button @click="sendText('Leo')">Leo</button>
            <button @click="sendText('Eissalon')">Eissalon</button>
            <button @click="sendText('Seeseiten')">Seeseiten</button>
            -->
          </li>
          <li>wie warm es draußen ist <button @click="sendText('Wetter')">Wetter</button></li>
          <li>ob es noch genug 🚲 Leihräder gibt <button @click="sendText('SeestadtFLOTTE')">SeestadtFLOTTE</button></li>
          <li>wo 🐶 Hundezonen und 💩 Sackerlspender sind <button @click="sendText('Hundezone')">Hundezone</button></li>
        </ul>
        <p>Weitere Funktionen <router-link to="/hilfe">findest du in der Online-Hilfe.</router-link></p>
      </div>
      <div class="top-grid-bot">
        <bot ref="seestadtbot" :fullscreen="!isDesktop"></bot>
      </div>
    </div>

    <section class="something-missing">
      <h2>Wie kannst du dich und dein Unternehmen im Seestadt.bot eintragen?</h2>
      <p>
        Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest ein Service in der Seestadt an?
        Der Seestadt.bot basiert auf dem StadtKatalog, wo du dich einfach einträgst und damit auch hier erscheinst.
        <a :href="proposalUrl" target="_blank">Eintrag vorschlagen</a>
      </p>
    </section>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import StadtKatalogSearch from "@/components/StadtKatalogSearch";
  import StadtKatalogPromotions from "@/components/StadtKatalogPromotions";
  import Bot from "./Bot";

  export default {
    name: "frontpage-seestadtbot",
    components: {
      Bot,
      "sk-search": StadtKatalogSearch,
      "sk-promotions": StadtKatalogPromotions
    },
    data () {
      return {
        demoQueries: [],
        isDesktop: true,
      }
    },
    computed: {
      ...mapState([
        "geoFenceName",
        "totalHits",
        "promotionEntries"
      ]),
      showSuggestions: function() {
        return this.totalHits <= 0;
      },
      showPromotions: function() {
        return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
      },
      proposalUrl: function() {
        return `https://app.stadtkatalog.org/stk/proposeEntry${this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : ""}`;
      }
    },
    methods: {
      sendText(text) {
        if (text && text.length <= 250) {
          if (text !== "") {
            this.$refs.seestadtbot.sendText(text);
          }
        } else {
          window.alert("Der Text darf maximal 250 Zeichen lang sein!");
        }
      },
      setQuery(query) {
        this.$store.commit("setQuery", query);
        this.$refs.search.queryStadtKatalog();
        this.$refs.search.focusSearchField();
      }
    },
    created() {
      const mql = window.matchMedia("(min-width: 1020px)");
      this.isDesktop = mql.matches === true;
      try {
        // Chrome & Firefox
        mql.addEventListener("change", () => {
          this.isDesktop = mql.matches === true;
        });
      } catch (e1) {
        try {
          // Safari
          mql.addListener((e) => {
            this.isDesktop = mql.matches === true;
          });
        } catch (e2) {
          console.error(e2);
        }
      }

      document.title = STADTKATALOG_CONFIG.siteName;
      this.$store.commit("resetQueryStates");
      this.$store.dispatch("updatePromotionEntries");
    },
    mounted() {
      const url = new URL(document.location);
      const text = url.searchParams.get("text");
      if (text) {
        this.$refs.seestadtbot.sendText(text);
        this.$router.replace({ path: '/', query: {}});
      }
    }
  }
</script>

<style lang="scss">
  @import "~sass-mq";
  @import "../assets/base";
  @import "../assets/seestadtbot/mixins";

  .seestadtbot-frontpage {
    section {
      margin: 2rem 0;
      padding: 0 3rem;
      font-size: 1.125rem;
      line-height: 1.5rem;
    }

    .something-missing {
      padding-top: 2rem;
    }

    @include mq($until: desktop) {
      .top-grid-content,
      .something-missing {
        display: none;
      }
    }

    .top-grid {
      @include mq($from: desktop) {
        display: grid;
        grid-template-rows: minmax(calc(100vh - var(--header-height-full)), auto);
        grid-template-columns: 50% auto;
      }

      @include mq($from: desktop, $until: wide) {
        grid-gap: 35px;
        margin: 0 20px;
      }

      @include mq($from: wide) {
        grid-gap: 60px;
      }
    }

    .top-grid-content {
      font-size: 1.125rem;
      line-height: 1.5rem;

      h2 {
        margin: 20px 0 0.5rem 0;
        text-align: center;
      }

      p {
        margin: 0.75rem 0;
      }

      .messenger-link-buttons {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 20px 0 40px 0;

        a {
          @include button-style;

          max-width: 50%;
          font-size: 1.6rem;
          margin-left: 0.5rem;

          img {
            height: 2rem;
            width: auto;
            margin-right: 10px;
          }
        }
      }

      ul {
        list-style-position: inside;
        padding-left: 0;
      }

      li {
        margin: 0.85rem 0;

        button {
          display: inline-flex;
          align-items: center;
          @include button-reset;
          vertical-align: text-top;
          color: #fff;
          font-size: 0.75rem;
          height: 1.5rem;
          padding: 0 0.5rem;
          margin-left: 5px;
          border-radius: 0.5rem;
          background: var(--header-color);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
          transition: all 0.3s cubic-bezier(.25, .8, .25, 1);

          &:hover,
          &:focus {
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
          }

          &::after {
            content: "";
            display: inline-block;
            background: url("../assets/seestadtbot/play.svg") no-repeat;
            background-size: contain;
            width: 0.75rem;
            height: 0.75rem;
            margin-left: 4px;
          }
        }
      }
    }

    /**
   * The chatbot messaging UI
   */
    .top-grid-bot {
      @include mq($until: desktop) {
        position: fixed;
        top: var(--header-height-small);
        left: 0;
        right: 0;
        bottom: 0;
      }

      @include mq($from: desktop) {
        .messaging {
          height: calc(100vh - var(--header-height-full) - 45px);
          margin: 20px 0;
          border: 1px solid #cfcfcf;
          border-radius: 15px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
          transition: all 0.3s cubic-bezier(.25, .8, .25, 1);

          &:hover,
          &:focus,
          &:focus-within {
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FrontPageSeestadtBot.vue